import { atom, useAtom } from 'jotai';

// '' - off, 'all' - every field editable, 'shipmentDetailsOnly' - shipment qtys + shipper/shipmentId (if allowed)
export type EditDeliveryMode = '' | 'all' | 'shipmentDetailsOnly';

export const editDeliveryModeAtom = atom<EditDeliveryMode>('');

export const useEditDeliveryMode = () => useAtom(editDeliveryModeAtom);
